export default "__VITE_ASSET__BxGrVRTX__"